module.exports = __webpack_public_path__ + "assets/img/2021-8.2becb0fa.png";